import React, { useState, useEffect } from "react"
import { Link } from "react-router-dom"
import { Col, Row, UncontrolledAlert, Spinner } from "reactstrap"
import api from "API/Api"
import { AvForm, AvField, AvRadioGroup, AvRadio } from "availity-reactstrap-validation"
import PageLoader from "./../../../assets/loading/pageLoad1.gif"

const AddCcSpoiledPurchase = () => {
  const [submitted, setSubmitted] = useState(false)
  const [loading, setLoading] = useState(false)
  const [pageLoad, setPageLoad] = useState(true)
  const [centers, setCenters] = useState([])
  const [routes, setRoutes] = useState([])
  const [collections, setCollections] = useState([])
  const [vendors, setVendors] = useState([])
  const [routesLoading, setRoutesLoading] = useState(false)
  const [collectionsLoading, setCollectionsLoading] = useState(false)
  const [reason, setReason] = useState("")

  useEffect(() => { getData() }, [])

  const getData = async () => {
    try {
      const [centersResp, vendorsResp] = await Promise.all([
        api.get("centers?per_page=500"), api.get("vendors?per_page=500")
      ])
      setCenters(Array.isArray(centersResp.data?.data) ? centersResp.data.data : centersResp.data?.data?.data || [])
      setVendors(Array.isArray(vendorsResp.data?.data) ? vendorsResp.data.data : vendorsResp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setPageLoad(false)
  }

  const onCenterChange = async (value) => {
    setRoutes([]); setCollections([])
    if (!value) return
    setRoutesLoading(true)
    try {
      const resp = await api.get("route-cc/" + value)
      setRoutes(Array.isArray(resp.data?.data) ? resp.data.data : resp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setRoutesLoading(false)
  }

  const onRouteChange = async (value) => {
    setCollections([])
    if (!value) return
    setCollectionsLoading(true)
    try {
      const resp = await api.get("collection-center-route/" + value)
      setCollections(Array.isArray(resp.data?.data) ? resp.data.data : resp.data?.data?.data || [])
    } catch (e) { console.error(e) }
    setCollectionsLoading(false)
  }

  const handleValidSubmit = async (event, values) => {
    setLoading(true); setSubmitted(false)
    try {
      const resp = await api.post("create-cc-spoiled-purchase", values)
      if (resp.data.success) { setSubmitted(true); setTimeout(() => setSubmitted(false), 4000) }
    } catch (e) { console.error(e) }
    setLoading(false)
  }

  const today = new Date().toISOString().split("T")[0]

  if (pageLoad) return <div className="pageLoader"><img src={PageLoader} alt="Loading..." /></div>

  return (
    <div className="dashBody">
      <div className="font-size-18 mb-0 dashHeader">
        <Row>
          <Col md={6}><h4>Report Spoiled Purchase</h4></Col>
          <Col md={6} style={{ textAlign:"right" }}><Link to="/cc-spoiled-purchases" className="dashBtn"><i className="fas fa-chevron-left"></i> <b>Back</b></Link></Col>
        </Row>
      </div>
      <div className="dashContent">
        <AvForm className="form-horizontal" onValidSubmit={(e, v) => handleValidSubmit(e, v)}>
          <h6 style={{ color:"#ef4444", borderBottom:"2px solid #fecaca", paddingBottom:"8px", marginBottom:"16px" }}><i className="fas fa-map-marker-alt"></i> Location Details</h6>
          <Row>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="chillingCenter" label="Chilling Center" required onChange={e => onCenterChange(e.target.value)}>
                <option value="">Select Chilling Center</option>
                {centers.map((c, i) => <option key={i} value={c.id}>{c.name}</option>)}
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="route" label={routesLoading?"Loading...":"Route"} required onChange={e => onRouteChange(e.target.value)}>
                <option value="">{routesLoading?"Loading...":"Select Route"}</option>
                {routes.map((r, i) => <option key={i} value={r.id}>{r.routeName}</option>)}
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="collectionCenter" label={collectionsLoading?"Loading...":"Collection Center"} required>
                <option value="">{collectionsLoading?"Loading...":"Select Collection Center"}</option>
                {collections.map((c, i) => <option key={i} value={c.id}>{c.centerName}</option>)}
              </AvField>
            </div></Col>
            <Col md={6}><div className="mb-3">
              <AvField type="select" name="vendor" label="Vendor">
                <option value="">Select Vendor (Optional)</option>
                {vendors.map((v, i) => <option key={i} value={v.id}>{v.vendorName || v.name}</option>)}
              </AvField>
            </div></Col>
          </Row>

          <h6 style={{ color:"#ef4444", borderBottom:"2px solid #fecaca", paddingBottom:"8px", marginBottom:"16px", marginTop:"8px" }}><i className="fas fa-exclamation-triangle"></i> Spoilage Details</h6>
          <Row>
            <Col md={4}><div className="mb-3"><AvField name="spoiledDate" label="Spoiled Date" type="date" value={today} required /></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="shift" label="Shift" required errorMessage="Pick one!"><AvRadio label="AM" value="0" /><AvRadio label="PM" value="1" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3"><AvRadioGroup inline name="milkType" label="Milk Type" required errorMessage="Pick one!"><AvRadio label="Cow" value="1" /><AvRadio label="Buffalo" value="2" /><AvRadio label="Common" value="3" /></AvRadioGroup></div></Col>
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="reason" label="Spoilage Reason" required onChange={e=>setReason(e.target.value)}>
                <option value="">Select Reason</option>
                <option value="adulteration">Adulteration</option>
                <option value="sour">Sour/Curdled</option>
                <option value="foreign_matter">Foreign Matter</option>
                <option value="expired">Expired</option>
                <option value="low_quality">Low Quality</option>
                <option value="other">Other</option>
              </AvField>
            </div></Col>
            {reason === "other" && (
              <Col md={8}><div className="mb-3"><AvField name="reasonDetails" label="Reason Details" type="textarea" rows="2" required /></div></Col>
            )}
            <Col md={4}><div className="mb-3">
              <AvField type="select" name="actionTaken" label="Action Taken" required>
                <option value="">Select Action</option>
                <option value="returned">Returned to Source</option>
                <option value="discarded">Discarded</option>
                <option value="reprocessed">Reprocessed</option>
              </AvField>
            </div></Col>
            <Col md={4}><div className="mb-3"><AvField name="reportedBy" label="Reported By" type="text" required /></div></Col>
          </Row>

          <h6 style={{ color:"#ef4444", borderBottom:"2px solid #fecaca", paddingBottom:"8px", marginBottom:"16px", marginTop:"8px" }}><i className="fas fa-flask"></i> Quantity & Quality</h6>
          <Row>
            <Col md={3}><div className="mb-3"><AvField name="qtyLtrs" label="Quantity (Liters)" type="number" step="0.01" required validate={{min:{value:0}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="qtyKg" label="Quantity (KG)" type="number" step="0.01" validate={{min:{value:0}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseFat" label="FAT" type="number" step="0.01" validate={{min:{value:0},max:{value:15}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseSnf" label="SNF" type="number" step="0.01" validate={{min:{value:0},max:{value:15}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="purchaseClr" label="CLR" type="number" step="0.01" /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="ratePerLtr" label="Rate/Ltr (₹)" type="number" step="0.01" validate={{min:{value:0}}} /></div></Col>
            <Col md={3}><div className="mb-3"><AvField name="estimatedLoss" label="Estimated Loss (₹)" type="number" step="0.01" validate={{min:{value:0}}} /></div></Col>
          </Row>

          <div className="mb-3 row mt-4">
            <div className="col-6">{submitted && <UncontrolledAlert color="success"><strong>Spoiled Purchase Recorded!</strong></UncontrolledAlert>}</div>
            <div className="col-6 text-end">
              <button className="btn btn-danger w-md waves-effect waves-light" type="submit" disabled={loading}>
                {loading ? <><Spinner animation="border" size="sm" /><span style={{paddingLeft:"10px"}}>Saving...</span></> : <span><i className="fas fa-exclamation-triangle"></i> Report Spoilage</span>}
              </button>
            </div>
          </div>
        </AvForm>
      </div>
    </div>
  )
}

export default AddCcSpoiledPurchase
